import React from 'react';
import { useLanguageStyles } from '../hooks/useLanguageStyles';
import '../styles/ko/main.css';
import '../styles/en/main.css';

const LanguageWrapper = ({ children }) => {
  // 언어별 CSS 자동 로딩
  useLanguageStyles();
  
  return <>{children}</>;
};

export default LanguageWrapper;
